import React from 'react';

const TrackingFooter = () => {
  return (
    <footer className="bg-white border-t border-gray-200">
      <div className="container mx-auto px-4 py-6">
        <div className="text-center">
          <p className="text-sm text-gray-600">
          © {new Date().getFullYear()} Wayuvega. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default TrackingFooter;